let bottleSlider = {};

bottleSlider.init = () => {
  let $slider = $('.js-bottle-slider');
  let cellAlign = 'center';
  if (!$slider) return;
  // console.log('init');

  if (window.innerWidth > 767) {
    cellAlign = 'center';
  } else {
    cellAlign = 'left';
  }

  $slider.flickity({
    pageDots: true,
    contain: true,
    cellAlign: cellAlign,
    percentPosition: false,
    dragThreshold: 10,
    prevNextButtons: $(window).innerWidth() >= 979.98,
    groupCells: false,
    freeScroll: false,
    wrapAround: true,
    autoPlay: true,
    pauseAutoPlayOnHover: false
  });
}

document.addEventListener('DOMContentLoaded', function (event) {
  bottleSlider.init();

  window.addEventListener('resize', () => {
    bottleSlider.init();
  });
});



// WEBPACK FOOTER //
// ./scripts/components/featured/history/modules/bottle_slider.js